import {
  Field,
  Image,
  ImageField,
  NextImage,
  useSitecoreContext,
} from "@sitecore-jss/sitecore-jss-nextjs";
import clsx from "clsx";
import { ComponentType, ComponentProps as ReactComponentProps } from "react";
import { ComponentProps } from "../../types/component-props";
import TopicHeader from "../customer-care/components/topic-header/topic-header";
import { useChatbotContext } from "../providers/chatbot-provider";
import { isMobile } from "../utils";
import styles from "./image-header.module.css";

export type ImageHeaderProps = ComponentProps & {
  fields: {
    data: {
      contextItem: {
        title: Field<string>;
        imageLarge: ImageField;
        imageMedium: ImageField;
      };
    };
  };
};

function withImageTitle<
  P extends {
    field: ReactComponentProps<typeof Image>["field"];
    title: Field<string>;
  },
>(Component: ComponentType<P>) {
  return (props: P) => {
    const { title } = props;

    return (
      <div
        className={clsx(styles.ccImageHeaderContainer)}
        data-testid="faq-hero"
      >
        <Component {...props} />
        <div className={styles.imageHeaderTextContainer}>
          <TopicHeader heading={title} className={"imageHeader"} tag={"h1"} />
        </div>
      </div>
    );
  };
}

const ImageWithTitle = withImageTitle(Image);

const ImageHeader = (props: ImageHeaderProps): JSX.Element => {
  const { contextItem } = props.fields.data;

  const { sitecoreContext } = useSitecoreContext();

  const isGetInTouch = sitecoreContext.route?.name.includes("Get In Touch");

  const mobileView = isMobile();

  const imageUrl = mobileView
    ? contextItem.imageMedium
    : contextItem.imageLarge;

  const { isChatbotActive } = useChatbotContext();

  if (isChatbotActive) return <></>;

  return (
    <>
      {isGetInTouch ? (
        <div className={styles.getInTouchImageHeaderContainer}>
          <NextImage
            unoptimized
            field={imageUrl}
            className={styles.headerImage}
          />
        </div>
      ) : (
        <ImageWithTitle
          field={imageUrl}
          title={contextItem.title}
          data-testid="hero-image"
        />
      )}
    </>
  );
};

export default ImageHeader;
